<!-- <button mat-raised-button color="primary" type="submit" class="uppercase" (click)="getDemo('')">Home</button>
<button mat-raised-button color="primary" type="submit" class="uppercase" (click)="getDemo('admin')">Admin</button> -->
 

<mat-drawer-container class="landing-page">
       
    <div class="p-3 header-section" id="top">
        <div class="theme-container">
            <div fxLayout="row wrap" class="content">
                <div fxFlex="100" class="mb-5 py-3"> 
                    <a routerLink="/admin" fxLayout="row" fxLayoutAlign="start center" class="logo"> 
                        <span>AKSHAYA AGRI</span> 
                    </a>
                </div>
                <div fxFlex="100" class="py-5"> 
                    <h1>Angular Material Design eCommerce Template</h1>
                    <h4 class="mt-3">AKSHAYA AGRI implements the official Angular Material Design components and built with Angular CLI.</h4>
                    <h4>No Bootstrap!, No jQuery! and Only TypeScript! Start creating your app with akshyaagri template, 6 color styles, 20+ pages.</h4>
                    <div class="py-5">
                        <button mat-raised-button color="primary" class="uppercase mx-2" (click)="scrollToDemos()">View demos</button> 
                        <a mat-raised-button color="warn" href="https://themeforest.net/item/akshyaagri-angular-material-design-ecommerce-template/21668189" target="_blank" class="uppercase mx-2">Purchase now</a> 
                    </div>
                </div>
            </div>
        </div>
    </div> 

    <div class="p-3">
        <div class="theme-container">

            <div fxLayout="row wrap" fxLayoutAlign="center" id="demos">
                <div fxFlex="100" class="text-center py-4"> 
                    <h1 class="fw-500">Check out our demo styles</h1>
                    <p>Fully responsive, organized folder structure, clean & customizable code, easy to use and much more...</p>
                </div>
                <div fxFlex="100" class="main-wrapper">

                    <div fxLayout="row wrap">
                        <div fxFlex="100" fxFlex.gt-sm="50" class="box">
                            <h2>eCommerce</h2>
                            <mat-card [style.background-image]="'url(assets/images/demos/homepage.jpg)'"></mat-card> 
                            <button mat-raised-button color="primary" type="submit" class="uppercase" (click)="getDemo(1)">View demo</button>
                            <button mat-raised-button color="warn" type="submit" class="uppercase" (click)="getDemo(2)">RTL</button>
                        </div>
                        <div fxFlex="100" fxFlex.gt-sm="50" class="box">
                            <h2>Admin Panel</h2>
                            <mat-card [style.background-image]="'url(assets/images/demos/admin.jpg)'"></mat-card>  
                            <button mat-raised-button color="primary" type="submit" class="uppercase" (click)="getDemo(3)">View demo</button>
                            <button mat-raised-button color="warn" type="submit" class="uppercase" (click)="getDemo(4)">RTL</button>
                        </div>
                      

                        <div fxFlex="100" class="text-center mt-3">                               
                            <h1>Skins</h1>
                            <p>Choose one of your favorite color style</p> 
                        </div>

                        <div fxFlex="100" fxFlex.gt-sm="33.3" fxFlex.sm="50" class="box">
                            <h2>Blue</h2>
                            <mat-card [style.background-image]="'url(assets/images/demos/blue.jpg)'"></mat-card>  
                            <!-- <button mat-raised-button color="primary" type="submit" class="uppercase" (click)="getSkin(1)">View demo</button> -->
                        </div>
                        <div fxFlex="100" fxFlex.gt-sm="33.3" fxFlex.sm="50" class="box">
                            <h2>Green</h2>
                            <mat-card [style.background-image]="'url(assets/images/demos/green.jpg)'"></mat-card> 
                            <!-- <button mat-raised-button color="primary" type="submit" class="uppercase" (click)="getSkin(2)">View demo</button> -->
                        </div>
                        <div fxFlex="100" fxFlex.gt-sm="33.3" fxFlex.sm="50" class="box">
                            <h2>Red</h2>
                            <mat-card [style.background-image]="'url(assets/images/demos/red.jpg)'"></mat-card> 
                            <!-- <button mat-raised-button color="primary" type="submit" class="uppercase" (click)="getSkin(3)">View demo</button> -->
                        </div>
                        <div fxFlex="100" fxFlex.gt-sm="33.3" fxFlex.sm="50" class="box">
                            <h2>Pink</h2>
                            <mat-card [style.background-image]="'url(assets/images/demos/pink.jpg)'"></mat-card> 
                            <!-- <button mat-raised-button color="primary" type="submit" class="uppercase" (click)="getSkin(4)">View demo</button> -->
                        </div>
                        <div fxFlex="100" fxFlex.gt-sm="33.3" fxFlex.sm="50" class="box">
                            <h2>Purple</h2>
                            <mat-card [style.background-image]="'url(assets/images/demos/purple.jpg)'"></mat-card> 
                            <!-- <button mat-raised-button color="primary" type="submit" class="uppercase" (click)="getSkin(5)">View demo</button> -->
                        </div>
                        <div fxFlex="100" fxFlex.gt-sm="33.3" fxFlex.sm="50" class="box">
                            <h2>Grey</h2>
                            <mat-card [style.background-image]="'url(assets/images/demos/grey.jpg)'"></mat-card> 
                            <!-- <button mat-raised-button color="primary" type="submit" class="uppercase" (click)="getSkin(6)">View demo</button> -->
                        </div>

                        <div fxFlex="100" class="py-4 px-3 text-right">
                            <button mat-mini-fab color="warn" (click)="goToTop()">
                                <mat-icon>keyboard_arrow_up</mat-icon>
                            </button>
                        </div>

                    </div>

                </div> 
            </div> 

        </div>
    </div>

    <mat-toolbar class="copyright">
        <div class="theme-container"> 
            <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-between center" class="w-100">
                <p ngClass.xs="mt-1">Copyright © 2019 All Rights Reserved</p>
                <p>Designed & Developed by <a mat-button href="http://themeseason.com/" target="_blank">ThemeSeason</a></p>
            </div>
        </div>
    </mat-toolbar> 

</mat-drawer-container>